import styled from 'styled-components';
import { rgba } from 'polished';
import { primary, neutral, white, season } from '../../../../style/colors';

export const Container = styled.div`
  padding: 0;
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;

export const BrandBadge = styled.div`
  font-size: 12px;
  color: ${white};
  background: linear-gradient(135deg, ${primary[500]} 0%, ${primary[400]} 100%);
  padding: 6px 14px;
  border-radius: 20px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px ${rgba(primary[500], 0.3)};
`;

const getSeasonBackground = (seasonType) => {
  if (seasonType === 'Winter') return season.winter;
  if (seasonType === 'Summer') return season.summer;
  return '#66bb6a';
};

export const SeasonBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  background: ${props => getSeasonBackground(props.season)};
  color: ${props => props.season === 'Winter' ? neutral[900] : white};
  padding: 6px 14px;
  border-radius: 20px;
  font-weight: 600;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  i {
    font-size: 14px;
  }
`;

export const Title = styled.h1`
  font-size: 36px;
  font-weight: 700;
  color: ${neutral[900]};
  margin-bottom: 12px;
  line-height: 1.2;
  letter-spacing: -0.5px;
`;

export const CatalogRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

export const CatalogNumber = styled.div`
  font-size: 14px;
  color: ${neutral[400]};
  font-weight: 500;
  letter-spacing: 0.3px;
`;

export const Headline = styled.div`
  font-size: 18px;
  color: ${neutral[500]};
  margin-top: 16px;
  line-height: 1.5;
`;
